import { useField } from 'formik'

export const useFields = (
  dateFieldName: string,
  timeWindowStartFieldName?: string,
  timeWindowEndFieldName?: string
) => {
  const [, { value: dateValue }, { setValue: setDateValue }] = useField(dateFieldName)
  const [, { value: timeWindowStartValue }, { setValue: setTimeWindowStartValue }] = useField(
    timeWindowStartFieldName || ''
  )
  const [, { value: timeWindowEndValue }, { setValue: setTimeWindowEndValue }] = useField(timeWindowEndFieldName || '')

  return {
    dateValue,
    timeWindowStartValue,
    timeWindowEndValue,
    setDateValue,
    setTimeWindowStartValue,
    setTimeWindowEndValue,
  }
}
